import { useEffect, useState } from "react";
import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import HotRank from "@/pages/home/components/HotRank";
import Scenes from "@/pages/home/components/Scenes";
import Memes from "@/pages/home/components/Memes";
import Topics from "@/pages/home/components/Topics";
import Faq from "@/pages/home/components/Faq";
import About from "@/pages/home/components/About";
import Contact from "@/pages/home/components/Contact";
import Footer from "@/pages/home/components/Footer";

function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-[0_10px_24px_-10px_oklch(var(--primary-700)/0.6)] transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
    </button>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <HotRank />
        <Scenes />
        <Memes />
        <Topics />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}